<template>
  <b-tabs class="te-tabs-mcf" :class="tabClass" :nav-class="tabNavClass">
    <b-tab v-for="(dept, index) in depts" :key="dept.no" :active="index === 0" @click="clickDeptTab(dept.detail)">
      <template v-slot:title>
        <div class="d-flex align-items-center" :class="[isMobile ? '' : 'text-mcf-color']">
          <span>{{ dept.name }}</span>
          <span class="active-bar bg-customize"></span>
        </div>
      </template>
    </b-tab>
    <b-tab v-if="showFavoriteTab" @click="clickFavoriteTab()">
      <template v-slot:title>
        <div class="d-flex align-items-center" :class="[isMobile ? '' : 'text-mcf-color']">
          <span>{{ favoriteTabWording }}</span>
          <span class="active-bar bg-customize"></span>
        </div>
      </template>
    </b-tab>
    <template v-slot:tabs-end>
      <slot />
    </template>
  </b-tabs>
</template>

<script>
import { forkJoin, of } from 'rxjs';
import {
  filter, map, tap, catchError,
} from 'rxjs/operators';
import { mapState, mapMutations } from 'vuex';

import pdiService from '@/services/pdiService';
import sctService from '@/services/sctService';
import pageSettingGetter from '@/utils/pageSettingGetter';

const emptyHint = {};
export default {
  data() {
    return {
      // 分類列表
      depts: [],
      // 最愛頁籤文案
      favoriteTabWording: '',
      // 資料是否完成載入
      loadingCompleted: false,
    };
  },
  computed: {
    ...mapState(['isMobile']),
    // 是否登入
    hasLogged() {
      return !!this.$store.state.accessToken;
    },
    // 顯示最愛頁籤
    showFavoriteTab() {
      const vm = this;
      // 有登入 && 資料完成載入
      return vm.hasLogged && vm.loadingCompleted;
    },
    tabClass() {
      return [this.isMobile ? 'font-size-md nav-tabs-light position-relative' : 'w-100'];
    },
    tabNavClass() {
      return [this.isMobile ? 'w-100 overflow-x flex-nowrap text-nowrap' : 'text-nowrap'];
    },
  },
  created() {
    const vm = this;
    // 取得頁面設定資料
    const getPageSetting = vm.$store.dispatch('getPageSetting', 'RedeemItem')
      .then((setting) => {
        vm.favoriteTabWording = pageSettingGetter.getFunctionWording(setting, 'Favorite');
        // 空白頁設定
        emptyHint.desc = pageSettingGetter.getFunctionWording(setting, 'FavoriteBlankPageWording');
        emptyHint.img = pageSettingGetter.getFunction(setting, 'FavoriteBlankPagePic').picUrl;
        emptyHint.class = 'w-50 m-auto';
      });
    // 取得分類頁籤資料，篩選取得分類下須有商品且商品必須為生效且可於前台顯示
    const getRedeemItemDepts = pdiService.getRedeemItemDepts({ companyId: vm.$store.state.companyId, itemActiveType: 2 }).pipe(
      filter((res) => res.response.status === '200'),
      map((res) => (res.response.data)),
      tap((depts) => {
        vm.depts = depts;
        // 預設第一個頁籤，回傳子分類列表
        vm.$emit('changeDetailDepts', depts[0].detail);
      }),
      catchError(() => of([])),
    );

    // 取得會員最愛兌禮商品
    let getMemberFavoriteRedeemItems = of([]);
    if (vm.hasLogged) {
      getMemberFavoriteRedeemItems = vm.getMemberFavoriteRedeemItems();
    }

    vm.$subscribeTo(
      forkJoin(
        getPageSetting,
        getRedeemItemDepts,
        getMemberFavoriteRedeemItems,
      ),
      () => {
        vm.loadingCompleted = true;
      },
    );
  },
  methods: {
    ...mapMutations('redeemItem', ['setFavoriteItemNoList']),
    // 點擊分類頁籤
    clickDeptTab(detailDepts) {
      const vm = this;
      // 取得會員的最愛兌禮商品資料
      vm.$subscribeTo(vm.getMemberFavoriteRedeemItems());
      // 回傳子分類列表
      this.$emit('changeDetailDepts', detailDepts);
    },
    // 點擊最愛頁籤
    clickFavoriteTab() {
      const vm = this;
      // 回傳空白頁設定
      vm.$emit('emptyHint', emptyHint);
      // 取得會員的最愛兌禮商品資料
      vm.$subscribeTo(vm.getMemberFavoriteRedeemItems(),
        (itemNoList) => {
          // 若最愛兌禮商品資料為空，設定為 [-1] (用於顯示空白頁)
          if (itemNoList.length === 0) itemNoList.push(-1);
          // 設定最愛商品編號列表，列表用
          vm.setFavoriteItemNoList(itemNoList);
          // 回傳子分類列表
          this.$emit('changeDetailDepts', []);
        });
    },
    // 取得會員的最愛兌禮商品資料
    getMemberFavoriteRedeemItems() {
      const vm = this;
      const headers = { accessToken: this.$store.state.accessToken };
      return sctService.getMemberFavoriteRedeemItems(headers).pipe(
        filter((res) => res.response.status === '200'),
        map((res) => (res.response.data)),
        tap((itemNoList) => {
          // 設定最愛商品編號列表 (兌禮卡片顯示愛心時使用)
          vm.$store.commit('redeemItem/set', { name: 'favoriteItemNos', value: itemNoList });
        }),
        catchError(() => of([])),
      );
    },
  },
};
</script>
